<template>
    <div>
        <div class="container">
            <div class="handle-box">
                <el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-add"
                    @click="addEdit(null, null, true)"
                >新增</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                row-key="id"
                ref="multipleTable"
                header-cell-class-name="table-header"
                v-loading="loading"
            >
                <el-table-column className="drag-item" prop="content" label="内容(拖拽排序)" align="center"></el-table-column>
                <el-table-column className="drag-item" label="显示状态" align="center" width="100">
                    <template slot-scope="scope">
                        {{getEnableType(scope.row.enable)}}
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="160">
                    <template slot-scope="scope">
                        <el-button 
                            v-if="scope.row.enable"
                            type="text"
                            icon="el-icon-edit"
                            @click="enableEdit(scope.row, 0)"
                        >不显示</el-button>
                        <el-button 
                            v-else
                            type="text"
                            icon="el-icon-edit"
                            @click="enableEdit(scope.row, 1)"
                        >显示</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="addEdit(scope.$index, scope.row, false)"
                        >修改</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination" v-if="totalPages > 1">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :current-page="currentPage"
                    :page-size="page_size"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
        <el-dialog :visible.sync="editVisible" width="50%">
            <el-form ref="rulesForm" :model="form" :rules="rules" label-width="100px">
                <el-form-item label="内容：" prop="content">
                    <el-input v-model="form.content" @input="onInput()"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer self-dialog-footer">
                <el-button type="primary" @click="saveEdit('rulesForm')">提 交</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import Sortable from "sortablejs"
import http from '../../../api/hemeraApiConfig'
export default {
    name: 'Userslist',
    data() {
        return {
            enables: [
                {"name": "不显示", "id": 0},
                {"name": "显示", "id": 1}
            ],
            tableData: [],
            currentPage: 1,
            totalPages: 1,
            page_size: 10,
            pageTotal: 10,
            loading: false,
            is_add: false,
            editVisible: false,
            rules: {
                content: [{ required: true, message: "请填写内容", trigger: "blur" }]
            },
            form: {}
        };
    },
    created() {
        this.getData();
    },
    methods: {
        getEnableType(id){
            return this.enables[id]["name"];
        },
        getData() {
            let that = this;
            that.loading = true;
            http.get("admin/hot_words").then(function(res) {
                that.tableData = res.data.data;
                that.currentPage = res.data.data.current_page;
                that.totalPages = res.data.data.total_pages;
                that.pageTotal = that.totalPages * that.page_size;
                that.loading = false;
                that.init();
            });
        },
        init() {
            // 一定要等页面先加载完后才调用，否则会报错
            this.$nextTick(() => {
                this.initSort()
            })
        },
        initSort() {
            let that = this;
            const el = document.querySelectorAll(
                ".table .el-table__body-wrapper > table > tbody"
            )[0] // 获取拖拽的容器 .table-list 一定是table上的class 如果是其他上的class名称，可能会无法拖拽
            this.sortable = Sortable.create(el, {
                ghostClass: "sortable-ghost",
                // handle: ".drag-item", // 指定推拽列
                setData: function (dataTransfer) {
                    dataTransfer.setData("Text", "")
                },
                onEnd: evt => {
                this.$nextTick(() => {
                    let params = {
                        index: evt.newIndex
                    }
                    http.put("admin/hot_words/"+that.tableData[evt.oldIndex]['id'], params).then(function(res) {
                        if (res.data.status_code == 200) {
                            that.getData();
                        }
                    });
                })
                }
            })
        },
        onInput(){
            this.$forceUpdate();
        },
        enableEdit(row, enable){
            let that = this;
            let params = {enable: enable}
            if(row.enable){
                that.$confirm('是否关闭显示?', '提示', {
                    type: 'warning'
                })
                .then(() => {
                    http.put("admin/hot_words/"+row.id, params).then(function(res) {
                        if (res.data.status_code == 200) {
                            that.$message.success('关闭成功');
                            that.getData();
                        }
                    });
                })
                .catch(() => {});
            }else{
                that.$confirm('是否显示?', '提示', {
                    type: 'warning'
                })
                .then(() => {
                    http.put("admin/hot_words/"+row.id, params).then(function(res) {
                        if (res.data.status_code == 200) {
                            that.$message.success('显示成功');
                            that.getData();
                        }
                    });
                })
                .catch(() => {});
            }
        },
        addEdit(index, row, add){
            this.is_add = add;
            if(add){
                this.form = {
                    content: ''
                }
            }else{
                this.form = {
                    id: row.id,
                    content: row.content
                }
            }
            this.editVisible = true;
        },
        saveEdit(formName){
            let that = this;
            that.$refs[formName].validate(valid => {
                if (valid) {
                    let params = {content: that.form.content}
                    if(that.is_add){
                        http.post("admin/hot_words", params).then(function(res) {
                            if (res.data.status_code == 200) {
                                that.$message.success(`新增成功`);
                                that.getData();
                                that.editVisible = false;
                            }else if(res.data.status_code == 50002){
                                that.$message.error(res.data.msg);
                            }
                        });
                    }else{
                        params['enable'] = that.form.enable;
                        params['index'] = that.form.index;
                        http.put("admin/hot_words/"+that.form.id, params).then(function(res) {
                            if (res.data.status_code == 200) {
                                that.$message.success(`修改成功`);
                                that.getData();
                                that.editVisible = false;
                            }
                        });
                    }
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.self-dialog-footer{
    display: block;
    text-align: center;
}
</style>
